import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ManagementSalesSearch } from "@/components/features/management/sales/search/ui";

import { useConfirmParams } from "./hooks";

export const ManagementSalesTopPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="収支の管理" url={generatePath(PATHS.HOTEL.MANAGEMENT.SALES.TOP, { hotelID })}>
			<ManagementSalesSearch hotelID={hotelID} />
		</PageMeta>
	);
};

ManagementSalesTopPage.displayName = "ManagementSalesTopPage";
